//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { db } from "../main.js";
export default {
  name: "Admin",
  data() {
    return {
      loaded: false,
      isCreating: false,
      editKey: null,
      classes: null,
      lessons: {},
      annotations: null,
      newAnnotation: {
        startTime: 0,
        name: "New annotation",
        description: "",
      },
    };
  },
  watch: {
    isCreating(newVal) {
      if (newVal === true) {
        this.newAnnotation.startTime = this.$refs.player.currentTime.toFixed(1);
      }
    },
  },
  methods: {
    addAnnotation(data) {
      data.startTime = this.timeToFloat(data.startTime);
      var annotationKey = db
        .ref(
          `annotations/${this.$store.state.currentClassKey}/${this.$store.state.currentLessonKey}`
        )
        .push().key;
      db.ref(
        `annotations/${this.$store.state.currentClassKey}/${this.$store.state.currentLessonKey}/${annotationKey}`
      ).set(data);
      this.isCreating = false;
    },
    updateDuration(player) {
      player
        .getDuration()
        .then((duration) =>
          db
            .ref(
              `lessons/${this.$store.state.currentClassKey}/${this.$store.state.currentLessonKey}/duration`
            )
            .set(Math.round(duration))
        );
    },
    timeToFloat(time) {
      var raw = String(time);
      if (raw.includes(":")) {
        var colon = raw.indexOf(":");
        return (
          parseInt(raw.substring(0, colon)) * 60 +
          parseInt(raw.substring(colon + 1))
        );
      } else return parseFloat(raw);
    },
  },
  async created() {
    await this.$store.dispatch("setClassByKey", this.$route.params.classKey);
    await this.$store.dispatch(
      "setLessonsByClassKey",
      this.$route.params.classKey
    );
    await this.$store.dispatch("setLessonByKey", this.$route.params.lessonKey);
    db.ref(
      `annotations/${this.$store.state.currentClassKey}/${this.$store.state.currentLessonKey}`
    ).on("value", (snapshot) => {
        this.$store.dispatch("setAnnotationsCurrentKeys");
    });
    this.loaded = true;
  },
};
